<script setup lang="ts">
const { t } = useI18n()

// Seo
useSeoMeta({
    titleTemplate: () => `%s - ${t('title')}`,
    title: () => t('form.title')
})
</script>

<template>
    <PageMainContainer>
        <SubmitForm />
    </PageMainContainer>
</template>
